import { Link } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { IPersonaSharedProps, Persona, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Separator } from 'office-ui-fabric-react/lib/Separator';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import Label from 'reactstrap/lib/Label';
import { IEmailArchive } from '../../../models/IEmailArchive';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import DateUtils from '../../../utils/DateUtils';
import { IEmailArchiveProps } from './IEmailArchiveProps';
import { IEmailArchiveState } from './IEmailArchiveState';

const getStyles = () => {
    return {
        root: {
            maxWidth: "100%",
            responsiveMode: true,
            color: '#005269'
        }
    }
};
const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%", fontSize: "13px", color: '#005269'
});
const responsiveMain = mergeStyles({
    margin: "0px auto",
    overflowX: "auto"
});
const responsiveTable = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%"
});
const responsiveTableContent = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    border: "1px solid #005269"
});
const responsiveTableRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269"
});
const responsiveTableHeaderRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269",
    backgroundColor: '#35AFD1', color: "#ffffff"
});
const responsiveTableBody = mergeStyles({
    display: "table-row-group"
});
const responsiveTableBodyCell = mergeStyles({
    display: "table-cell",
    padding: "5px"
});
const responsiveTableBodyCellText = mergeStyles({
    display: "table-cell",
    padding: "5px",
    verticalAlign: "middle",
    textAlign: "left",
    fontWeight: "bold"
});
const responsiveTableBodyCellSpan = mergeStyles({
    width: "75%", textAlign: "left", overflow: "hidden", textOverflow: "ellipsis", display: "block", whiteSpace: "nowrap"
});
const responsiveTableBodyCellNavigation = mergeStyles({
    display: "table-cell",
    padding: "5px",
    verticalAlign: "middle",
    textAlign: "right",
    fontWeight: "bold"
});
const submitButton = mergeStyles({ backgroundColor: '#73797D', marginRight: "5px" });
const innerPanel = mergeStyles({ margin: "0 auto", width: "auto", maxWidth: "100%", color: '#005269', paddingBottom: "5px" });
const userMessage = mergeStyles({ fontSize: "13px", fontWeight: "bold", paddingBottom: "5px" });
const mailMessage = mergeStyles({ textAlign: "justify", padding: "5px" });
const textBoxPanel = mergeStyles({ display: "inline-block", verticalAlign: "bottom", marginRight: "5px", minWidth: "40%" });

export interface IDetailsList {
    key: string;
    fromEmailAddress: string;
    toEmailAddress: string;
    subject: string;
    message: string;
    sentDate: Date;
    category: string;
}
export default class EmailArchive extends React.Component<IEmailArchiveProps, IEmailArchiveState>
{

    private connectionContext: ConnectionContext;
    private userHandler: any;
    private dialog: IModalDialog;
    private allItems: IDetailsList[];

    constructor(props: IEmailArchiveProps, state: IEmailArchiveState) {
        super(props);
        this.connectionContext = this.props.connectionContext;
        this.allItems = [];

        this.state = {
            inputError: 'This field is Required',
            hideDialog: true,
            items: [],
            searchString: "",
            isOpen: false,
            fromEmailAddress: "",
            toEmailAddress: "",
            subject: "",
            message: "",
            sentDate: new Date(Date.now()),

            totalRecords: 0,
            startIndex: 0,
            recordsToShow: 20,
            endIndex: 20
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
        this.getEmailArchive = this.getEmailArchive.bind(this);
    }

    public async componentDidMount() {
        this.getEmailArchive();
    }
    public getEmailArchive = async (): Promise<void> => {
        try {
            let emailArchive: IEmailArchive[] = await this.connectionContext.get("EmailArchive");
            this.setState((prevState: IEmailArchiveState): IEmailArchiveState => {
                this.allItems = [];
                prevState.items = [];
                emailArchive.forEach((item: IEmailArchive) => {
                    prevState.items.push({
                        key: item.id || "", fromEmailAddress: item.fromEmailAddress, toEmailAddress: item.toEmailAddress,
                        subject: item.subject, message: item.message, category: item.category, sentDate: item.sentDate
                    });

                    this.allItems.push({
                        key: item.id || "", fromEmailAddress: item.fromEmailAddress, toEmailAddress: item.toEmailAddress,
                        subject: item.subject, message: item.message, category: item.category, sentDate: item.sentDate
                    });
                })
                prevState.endIndex = (prevState.items.length > prevState.recordsToShow ? prevState.recordsToShow : prevState.items.length);
                return prevState;
            });

        } catch (exception) {
            this.handleError("Timed out", "Your session has expired. Please login again.");
        }

    }
    public openPanel = (item: IDetailsList): void => {

        this.setState((prevState: IEmailArchiveState): IEmailArchiveState => {
            prevState.fromEmailAddress = item.fromEmailAddress;
            prevState.toEmailAddress = item.toEmailAddress;
            prevState.subject = item.subject;
            prevState.message = item.message;
            prevState.isOpen = true;
            return prevState;
        });

    }
    public dismissPanel = (): void => {
        this.setState((prevState: IEmailArchiveState): IEmailArchiveState => {
            prevState.isOpen = false;
            return prevState;
        });
    }
    public firstSet = (): void => {
        this.setState((prevState: IEmailArchiveState): IEmailArchiveState => {
            prevState.startIndex = 0;
            prevState.endIndex = (prevState.recordsToShow > prevState.items.length ? prevState.items.length : prevState.recordsToShow);
            return prevState;
        });
    }
    public lastSet = (): void => {
        this.setState((prevState: IEmailArchiveState): IEmailArchiveState => {
            if (prevState.recordsToShow > prevState.items.length) {
                prevState.startIndex = 0;
                prevState.endIndex = prevState.items.length;
            }
            else {
                let balanceRecord: number = 0;
                balanceRecord = Math.ceil(prevState.items.length % prevState.recordsToShow);
                if (balanceRecord > 0) {
                    prevState.startIndex = prevState.items.length - balanceRecord;
                    prevState.endIndex = prevState.items.length;
                }
                else {
                    prevState.startIndex = prevState.items.length - prevState.recordsToShow;
                    prevState.endIndex = prevState.items.length;
                }
            }
            return prevState;
        });
    }
    public previousSet = (): void => {
        this.setState((prevState: IEmailArchiveState): IEmailArchiveState => {
            prevState.startIndex = (prevState.startIndex - prevState.recordsToShow <= 0 ? 0 : prevState.startIndex - prevState.recordsToShow);
            prevState.endIndex = (prevState.recordsToShow + prevState.startIndex > prevState.items.length ? prevState.items.length : prevState.recordsToShow + prevState.startIndex);
            return prevState;
        });
    }
    public nextSet = (): void => {
        this.setState((prevState: IEmailArchiveState): IEmailArchiveState => {
            prevState.startIndex = prevState.endIndex;
            prevState.endIndex = (prevState.endIndex + prevState.recordsToShow > prevState.items.length ? prevState.items.length : prevState.endIndex + prevState.recordsToShow);
            return prevState;
        });
    }
    public render(): React.ReactElement<IEmailArchiveProps> {
        const examplePersona: IPersonaSharedProps = {
            secondaryText: DateUtils.getFormatedDateWithTime(this.state.sentDate),
            tertiaryText: '',
            optionalText: ''
        };
        return (
            <div className={panel} >
                {
                    <Panel
                        isOpen={this.state.isOpen}
                        onDismiss={this.dismissPanel}
                        type={PanelType.large}
                        closeButtonAriaLabel="Close"
                        headerText={this.state.subject}
                    >
                        <div>{"Sender: " + this.state.fromEmailAddress}</div>
                        <Persona {...examplePersona} text={this.state.toEmailAddress} size={PersonaSize.size48} initialsColor="#005269" />
                        <Separator></Separator>
                        <div className={mailMessage} dangerouslySetInnerHTML={{ __html: (this.state.message) }}></div>
                    </Panel>
                }
                {
                    <div className={userMessage}>
                        Search by a keyword
                    </div>
                }
                {
                    <div className={innerPanel}>
                        <div className={textBoxPanel}>
                            <SearchBox required placeholder="Search by a keyword" styles={getStyles} onChange={this.getErrorMessageEM}
                                maxLength={40} value={this.state.searchString} onSearch={this.submitForm} />
                        </div>
                        <div className={textBoxPanel}>
                            <PrimaryButton text="Go" data-automation-id="test" className={submitButton} onClick={this.submitForm} iconProps={{ iconName: 'Filter' }} />
                        </div>
                    </div>
                }
                {
                    <div className={responsiveMain}>
                        <div className={responsiveTable}>
                            <div className={responsiveTableBody}>
                                <div className={responsiveTableRow}>
                                    <div className={userMessage}>* Click on 'Expand' to view the mail content.</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.startIndex === 0 ? "" : <Link onClick={this.firstSet}>|&laquo; First</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.startIndex === 0 ? "" : <Link onClick={this.previousSet}>&laquo; Previous</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.endIndex >= this.state.items.length ? "" : <Link onClick={this.nextSet}>Next &raquo;</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.endIndex >= this.state.items.length ? "" : <Link onClick={this.lastSet}>Last &raquo;|</Link>}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    <div className={responsiveMain}>
                        <div className={responsiveTableContent}>
                            <div className={responsiveTableBody}>
                                <div className={responsiveTableHeaderRow}>
                                    <div className={responsiveTableBodyCellText}><strong>Sender</strong></div>
                                    <div className={responsiveTableBodyCellText}><strong>Recipient</strong></div>
                                    <div className={responsiveTableBodyCellText}><strong>Subject</strong></div>
                                    <div className={responsiveTableBodyCellText}><strong>Sent on</strong></div>
                                    <div className={responsiveTableBodyCellText}><strong></strong></div>
                                </div>
                                {
                                    this.state.items.slice(this.state.startIndex, this.state.endIndex).map((item, i) => {
                                        return (
                                            <div className={responsiveTableRow}>
                                                <div className={responsiveTableBodyCell}><span className={responsiveTableBodyCellSpan}>{item.fromEmailAddress}</span></div>
                                                <div className={responsiveTableBodyCell}><span className={responsiveTableBodyCellSpan}><a href="mailto:{item.toEmailAddress}" target="_blank" rel="noopener noreferrer"> {item.toEmailAddress}</a></span></div>
                                                <div className={responsiveTableBodyCell}><span className={responsiveTableBodyCellSpan}>{item.subject}</span></div>
                                                <div className={responsiveTableBodyCell}><span className={responsiveTableBodyCellSpan}>{DateUtils.getFormatedDateWithTime(item.sentDate)}</span></div>
                                                <div className={responsiveTableBodyCell}><Link onClick={() => this.openPanel(item)}>Expand</Link></div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    <div className={responsiveMain}>
                        <div className={responsiveTable}>
                            <div className={responsiveTableBody}>
                                <div className={responsiveTableRow}>
                                    <div className={userMessage}>* Click on 'Expand' to view the mail content.</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.startIndex === 0 ? "" : <Link onClick={this.firstSet}>|&laquo; First</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.startIndex === 0 ? "" : <Link onClick={this.previousSet}>&laquo; Previous</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.endIndex >= this.state.items.length ? "" : <Link onClick={this.nextSet}>Next &raquo;</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.endIndex >= this.state.items.length ? "" : <Link onClick={this.lastSet}>Last &raquo;|</Link>}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    <div>
                        <div>
                            <Dialog
                                hidden={this.state.hideDialog}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: this.dialog.dialogMessage,
                                }}
                                maxWidth="1024px"
                                closeButtonAriaLabel="Close"
                            >
                                <div>
                                    <div>
                                        <Label> {this.dialog.dialogBody} </Label>
                                    </div>
                                </div>
                                <DialogFooter>
                                    <DefaultButton onClick={this.closeModelPopUp} data-automation-id="test" text="Close" className={submitButton} iconProps={{ iconName: "ChromeClose" }} />
                                </DialogFooter>
                            </Dialog>

                        </div>
                    </div>
                }
            </div>
        )
    }
    private submitForm = (): void => {
        var value: string = this.state.searchString;
        this.setState({
            items: value ? this.allItems.filter(i => i.fromEmailAddress.toLowerCase().indexOf(value) > -1 || i.toEmailAddress.toLowerCase().indexOf(value) > -1
                || i.subject.toLowerCase().indexOf(value) > -1 || i.message.toLowerCase().indexOf(value) > -1) : this.allItems
        });
    }
    private getErrorMessageEM = (event?: React.ChangeEvent<HTMLInputElement>, value?: string): void => {
        this.setState((prevState: IEmailArchiveState): IEmailArchiveState => {
            let newValue = value || '';
            prevState.inputError = '';
            prevState.searchString = newValue;
            if (newValue === "") {
                this.submitForm();
            }
            return prevState;
        });
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IEmailArchiveState): IEmailArchiveState => {
            previousState.hideDialog = false;
            return previousState;
        });
    }
    private closeModelPopUp = (): void => {
        this.setState((previousState: IEmailArchiveState): IEmailArchiveState => {
            previousState.hideDialog = true;
            return previousState;
        });
    }
}